module.exports = __webpack_public_path__ + "img/HowtoCategory1.8caea30d.png";